import { configureStore } from "@reduxjs/toolkit"

import routingSlice from "./slices/routingSlice/routingSlice"
import authSlice from "./slices/auth"
import linkingReducer from "./slices/linkingSlice"
import c2cSclice from "./slices/c2cSlice"
import settingsSBPSlice from "./slices/settingsSBP"
import m2mSlice from "./slices/m2mSlice"
import c2bSlice from "./slices/c2bSlice"
import operationsHistorySlice from "./slices/operationsHistorySlice"
import headerReducer from "./slices/headerSlice"
import paymentSlice from "./slices/payment"
import registrationSlice from "./slices/registration"

export const store = configureStore({
  reducer: {
    routing: routingSlice,
    accountLinkingForm: linkingReducer,
    transferForm: c2cSclice,
    auth: authSlice,
    settingsSBPForm: settingsSBPSlice,
    refillM2M: m2mSlice,
    c2bPayment: c2bSlice,
    operationsHistory: operationsHistorySlice,
    header: headerReducer,
    payment: paymentSlice,
    registration: registrationSlice,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
